<div *ngIf="isLoading" class="loading">
  <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
</div>

<con-page-layout>
  <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="16px">
    <h2>{{ 'accounts_title' | translate }}</h2>
    <div fxFlex></div>
  </div>
  <div class="sub-title">{{ 'accounts_subTitle' | translate }}</div>
  <div fxLayout="row" fxLayoutAlign="end start">
    <a mat-raised-button color="primary" (click)="sidenavaccount.open()">
      <mat-icon>add</mat-icon>{{ 'add_account' | translate }}
    </a>
  </div>

  <con-page-layout-content fxLayout="column" fxLayoutGap="16px">
    <mat-sidenav-container [hasBackdrop]="false">
      <mat-sidenav class="sidenav-panel" #sidenavaccount mode="over" position="end" [fixedInViewport]="true"
                   [fixedTopGap]="isMobile() ? 120 : 64" [disableClose]="true">
        <app-add-account [account]="account" (saved)="sidenavaccount.close(); addedAccount($event)"
                         (cancelled)="sidenavaccount.close(); cancelledAccount($event)" (loadingSpinner)="loadingSpinner($event)">
        </app-add-account>
      </mat-sidenav>
    </mat-sidenav-container>

    <div *ngIf="media.isActive('lg') || media.isActive('xl') || media.isActive('md')" class="matTable-container mat-elevation-z8">
      <mat-table matSort #table [dataSource]="dataSource" class="mat-elevation-z8">

        <!-- Account Name Column -->
        <ng-container cdkColumnDef="account_name">
          <mat-header-cell fxFlex="45%" *cdkHeaderCellDef mat-sort-header>{{ 'account_name' | translate }}</mat-header-cell>
          <mat-cell fxFlex="45%" *cdkCellDef="let account"> {{account.account_name}} </mat-cell>
        </ng-container>

        <!-- Account ID Column -->
        <ng-container cdkColumnDef="account_id">
          <mat-header-cell fxFlex="50%" *cdkHeaderCellDef mat-sort-header>{{ 'account_id' | translate }}</mat-header-cell>
          <mat-cell fxFlex="50%" *cdkCellDef="let account"> {{account.account_id}} </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="menu">
          <mat-header-cell fxFlex="5%" *cdkHeaderCellDef></mat-header-cell>
          <mat-cell fxFlex="5%" *cdkCellDef="let account">

            <button mat-icon-button [matMenuTriggerData]="{ row: account }" [matMenuTriggerFor]="menu" *ngIf="isContributor">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="updateAccount(account)" matTooltip="Modify Account"
                      matTooltipPosition="left">
                {{ 'edit' | translate }}
              </button>
            </mat-menu>

          </mat-cell>
        </ng-container>

        <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
        <mat-row *cdkRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
    </div>

    <br />
    <!-- Mobile view -->
    <div *ngIf="!(media.isActive('lg') || media.isActive('xl') || media.isActive('md'))" class="mobile-container mobile-accounts">
      <mat-list class="mobile-list">
        <mat-list-item *ngFor="let account of dataSource.data; trackBy: trackByAccountId" disableRipple>
          <div class="mobile-card">
            <div class="card-header"> {{ account.account_name }} </div>

            <div class="card-body">
              <div class="row">
                <span class="label">{{ 'account_id' | translate }}</span>
                <span class="value">{{ account.account_id }}</span>
              </div>
            </div>

            <div class="card-actions" *ngIf="isContributor">
              <button mat-stroked-button color="primary" (click)="updateAccount(account)"> {{ 'edit' | translate }} </button>
            </div>
          </div>
        </mat-list-item>
      </mat-list>
    </div>

  </con-page-layout-content>
</con-page-layout>
